module.exports = __webpack_public_path__ + "static/media/isotype.57353fc2.png";